import React, { useEffect, useRef, useState } from "react";
import FcModuleStyle from "../styles/fc.module.css";
import Button from "../../common/Button";
import help from "../../../assets/help.png";
import ReactDOM from "react-dom";
import { requiredMonthlyDemands, seasonalIndex, prevYearLastMonthActualDemand, prevYearLastMonthEXP_2, prevYearLastMonthEXP_5} from "./Prework-data";
import { useOutletContext } from "react-router-dom";
import { index } from "d3";
import info1 from "../assets/info1.png";
import { get_prework, UpdateDataPrework, retry_prework } from '../services/api';
import { getSession, setSession } from "../../../App";
const Prework = ({from,data}) => {
    const [prework, setPrework] = useState(null)
    const [copyPrework, setCopyPrework] = useState(null)
    const [isSave, setIsSave] = useState(false);
    const [isRequestLoading,setIsRequestLoading] = useState(false);
    const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError, error, simType, fcPopup, setFcPopup , relaunchPopup, setRelaunchPopup] = useOutletContext();
    const [isIntroductionOpen, setIsIntroductionOpen] = useState(true);
    const [isStepsContainerOpen, setIsStepsContainerOpen] = useState(true);
    const [isScenarioContainerOpen, setIsScenarioContainerOpen] = useState(true);
    const [isActivityOpen, setIsActivityOpen] = useState(true);
    const [isActivity2Open, setIsActivity2Open] = useState(true);
    const [requiredActualDemands, setRequiredActualDemands] = useState(null);
    const [focusedIndex,setFocusedIndex] = useState(11);
    const [liveMessage, setLiveMessage] = useState('');
    const [feedbackMessage, setFeedbackMessage] = useState("");
    const scoreBlockRef = useRef(null);
    // const scoreDivRef = useRef(null);
    // const [focusedScoreDiv, setFocusedScoreDiv] = useState(false);
    const months = [
        { short: "JAN", full: "January" },
        { short: "FEB", full: "February" },
        { short: "MAR", full: "March" },
        { short: "APR", full: "April" },
        { short: "MAY", full: "May" },
        { short: "JUN", full: "June" },
        { short: "JUL", full: "July" },
        { short: "AUG", full: "August" },
        { short: "SEPT", full: "September" },
        { short: "OCT", full: "October" },
        { short: "NOV", full: "November" },
        { short: "DEC", full: "December" },
    ];
    const forecastTechniques = ["3–Month Moving Forecast", "Exponential Smoothing Forecast for .2", "Exponential Smoothing Forecast for .5", "Naïve Forecast", "Seasonal Forecast"];
    const correctForecastTechnique = "Seasonal Forecast";
    const isToActivateToaster = useRef(false);
    const updatedMonth = useRef(null);
    const thRefs = useRef([]);
    const [isAccordionOpen, setIsAccordionOpen] = useState({
        'year1': true,
        'year2': true,
    });

    const getTotal = (arr) => {
        return arr?.reduce( (acc, curr) => {
          if(parseInt(curr)){
            return acc + parseInt(curr);
          }
          else{
            return acc;
          }
        }, 0 )
      }
    
    

    const handlePopupExitSim = (e) => {
        window.close();
      }

    const checkKey = (event) => {
        if (event.type == "keydown" && /Android|iPad/i.test(navigator.userAgent)) {
            return
        }
        let key = ""
        if(event.type == "keydown" && event.key && event.key != "unidentified"){
            key = event.key;
        }
        if(event.type == "input" && event.data && event.data != "")
        {
            key = event.data[event.data.length-1]
        }


        // Allow control keys: backspace, delete, arrow keys, etc.
        const controlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab'];  
        // Allow only one decimal point
        // const isDecimalPoint = event.key === '.' && !event.target.value.includes('.');
        const isDecimalPoint = key === '.' && !event.target.value.includes('.');

        if (
        !controlKeys.includes(event.key) && // Allow control keys
        !(key >= '0' && key <= '9') && // Allow number keys
        !isDecimalPoint // Allow one decimal point
        ) {
            if(event.type == "input" && event.data){
                event.target.value = event.target.getAttribute("data-value")
            }
            else{
                event.preventDefault();
            }
            return ;
        }
    }

    const updateForecastNextYear = (e,i) => {
        // debugger;
        const { value } = e.target;
        if (/^\d{0,3}$/.test(value)) {
            setCopyPrework((prevCopyPrework)=>(
                {
                ...prevCopyPrework,
                    attemptdata : {
                        ...prevCopyPrework.attemptdata,
                        ['year2ForecastNextPeriod'] : [...prevCopyPrework?.attemptdata?.year2ForecastNextPeriod].map((item,index)=>{
                            if(i === index){
                                return value;
                            }
                            else{
                                return item;
                            }
                        })
                    }
                }
            ));
            updatedMonth.current = i;
        }
        //   setIsSave(true);
    }

    const updateYear2ActualDemand = (e,i) => {
        const { value } = e.target;
        if (/^\d{0,3}$/.test(value)) {
        setCopyPrework((prevCopyPrework)=>(
            {
              ...prevCopyPrework,
              attemptdata : {
                ...prevCopyPrework.attemptdata,
                  ['year2ActualDemands'] : [...prevCopyPrework?.attemptdata?.year2ActualDemands].map((item,index)=>{
                    if(i === index){
                      return value
                    }
                    else{
                      return item
                    }
                  })
              }
            }
          ))
        }
        //   setIsSave(true);
    }

    const calculateScore = () => {
        let score = 0;
        let filledForecastNextPeriodInpLen = copyPrework?.attemptdata?.year2ForecastNextPeriod?.filter((demand)=> demand!= null && demand!="")?.length;
        // let filledActualDemandInpLen = copyPrework?.attemptdata?.year2ActualDemands?.filter((demand)=> demand!= null && demand!="")?.length;
        let filledActualDemandInpLen = Array.from(document.querySelectorAll("#actualDemandTable input"))?.filter((ele)=> ele.value!= null && ele.value!="")?.length;

        // if((filledForecastNextPeriodInpLen == 12) && (filledActualDemandInpLen == 12)){
        //     score += 4;
        // }

        months.forEach((month, index) => {
            const inputValue = copyPrework?.attemptdata?.year2ForecastNextPeriod?.[index];
            if (inputValue!= "" && (inputValue == getClosestForecastError("year2", index))) {
                score += 7.5;
            }
        });

        if(copyPrework?.attemptdata?.bestForecastTechnique && copyPrework?.attemptdata?.bestForecastTechnique==correctForecastTechnique){
            score+=10;
        }

        return score;
    }

    
    useEffect(()=>{
        if(copyPrework?.completed && !(prework?.completed)){
          setIsSave(true);
        }
      },[copyPrework?.completed,prework?.completed])
    
    const submitPrework = () => {
        // setFocusedScoreDiv(true);
        window.$("#actualDemandTable").attr("aria-hidden","true");
        setCopyPrework((prevCopyPrework)=>(
          {
          ...prevCopyPrework,
          ['completed'] : 1,
          ['score'] : calculateScore()
          }
        ));
        // setIsSave(true);
        setTimeout(() => {
            // window.$("#preworkScoreBlock").attr("tabindex","-1").focus();
            window.$("#actualDemandTable").removeAttr("aria-hidden");
        }, 100);
   
        setTimeout(() => {
            // Focus the sign first
            const signEl = document.getElementById("forecastResultSign");
            if (signEl) {
            signEl.focus();

            // After a pause, move focus to the score block
            setTimeout(() => {
                if (scoreBlockRef.current) {
                scoreBlockRef.current.focus();
                }
            }, 1200); // delay lets SR finish reading the sign
            }
        }, 100);
    }
    function randomizeDemands(demands, variation) {
        return demands.map(demand => Math.round(demand * (1 + variation)));
    }
    const setInitialData = () => {
        // window.$('.ui.dropdown').dropdown('clear');
        const index = Math.floor(Math.random() * (requiredMonthlyDemands.length - 1));
        let required_monthly_demands = requiredMonthlyDemands[index];

        let variation = Math.random() * 0.2 - 0.1;

        required_monthly_demands.year1ActualDemands = randomizeDemands(required_monthly_demands.year1ActualDemands,variation)
        required_monthly_demands.year2ActualDemands = randomizeDemands(required_monthly_demands.year2ActualDemands,variation)

        setCopyPrework((prev) => ({
                ...prev,
                attemptdata: {
                ['required_monthly_demands'] : required_monthly_demands,
                ['year2ActualDemands']:  required_monthly_demands.year2ActualDemands,
                ['year2ForecastNextPeriod']:  new Array(12).fill("")
            }
          }))
        window.$(".firstHeading").attr("tabindex", "-1").focus();
        window.$("html, body").animate(
          {
            scrollTop: 0,
          },
          100
        );
        setIsSave(true);
    }

    const getPrework = () => {
        if(!isRequestLoading){
          setIsRequestLoading(true);
          get_prework().then((response) => {
            if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
              // setError(response?.data)
            }
            else {
              if (typeof response != 'undefined') {
                setPrework(response?.data);
                setCopyPrework(response?.data)
                setIsLoader(false);
                setIsOverlay(false);
                setIsRequestLoading(false);
              }
            }
          }).catch((error) => {
            console.log(error);
          })
        }
    }

    const updatePrework = () => {
    if(!isRequestLoading){
        setIsRequestLoading(true);
        setTimeout(() => {
        if (copyPrework != {}) {
            UpdateDataPrework(copyPrework).then((response) => {
            if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                setError(response?.data)
            }
            else {
                if (typeof response != 'undefined') {
                    if(isToActivateToaster.current){
                        isToActivateToaster.current = false;
                        window.$('#saveToaster').show().transition('fade in');
                            document.querySelector("#saveToaster").setAttribute("aria-hidden","false");
        
                            // Hide the message after 5 seconds
                            setTimeout(function() {
                            window.$('#saveToaster').transition('fade out').hide();
                            document.querySelector("#saveToaster").setAttribute("aria-hidden","true")
                            }, 3000);
                        }
                    setPrework(response?.data);
                    setIsSave(false);
                    setCopyPrework(response?.data);
                    setIsRequestLoading(false);
                }
            }
            }).catch((error) => {
            console.log(error);
            })
        }
        }, 100)
    }
    }

    const resetPrework = () => {
        setTimeout(() => {
          if (copyPrework != {}) {
              retry_prework(copyPrework.sessionid).then((response) => {
                  if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                      setError(response?.data)
                  }
                  else {
                      if (typeof response != 'undefined' ) {
                        //   setPrework(response?.data);
                        setRequiredActualDemands(null);
                          if(response.status === 200){
                              getPrework();
                          }
                      }
                  }
                  // Set the focused index to 11 after handling the response
                    setFocusedIndex(11);
              }).catch((error) => {
                  // setError("Only instructor can change settings.");
                  //setError({"id":"00000","msg":"Only instructor can change settings."})
                  console.log(error);
              })
          }
      }, 100)
    }

    const preworkStyle = {
        width: "87.5%",
        margin: "auto",
        paddingTop: "15px",
    };

    const formatNum = (num) => {
        return num?.toLocaleString('en-US', { style: 'decimal' });
    }

    const setColumnWidths = () => {
        // debugger;
        thRefs.current.forEach((th, index) => {
            const td = document.querySelectorAll(`.${FcModuleStyle["nested-table"]} td:nth-child(${index + 1})`);
            td.forEach(cell => {
                cell.style.width = `${th.offsetWidth}px`;
            });
        });
    };
   
    const toggleAccordion = (year) => {
        setIsAccordionOpen((prevState) => ({
            ...prevState,
            [year]: !prevState[year],
        }), () => {
                if (isAccordionOpen[year]) {
                    setTimeout(setColumnWidths, 0); // Set column widths after the accordion has opened
                }
            });
    };

    const getActualDemand = (currIndx) => {
        if(currIndx == -1){
            return prevYearLastMonthActualDemand;
        }
        return requiredActualDemands?.year1ActualDemands?.[currIndx];
    }

    const getActualDemandYear2 = (currIndx) => {
        if(currIndx < 0){
            return parseInt(requiredActualDemands?.year1ActualDemands?.[requiredActualDemands?.year1ActualDemands?.length + currIndx]) || '';
        }
        return parseInt(copyPrework?.attemptdata?.year2ActualDemands?.[currIndx]) || '';
    }
    const calculateNaiveForecast = (year,currIndx) => {
        if(year == "year1"){
            return getActualDemand([currIndx-1]);
        }
        else if(year == "year2"){
            return getActualDemandYear2(currIndx - 1);
        }
    }

    const getNaiveForecastError = (year,currIndx) => {
        if(year == "year1"){
            return getActualDemand([currIndx]) - calculateNaiveForecast(year,currIndx);
        }
        else if(year == "year2"){
            if(getActualDemandYear2([currIndx])!= '' && calculateNaiveForecast(year,currIndx)!= ''){
                return getActualDemandYear2([currIndx]) - calculateNaiveForecast(year,currIndx);
            }
            else{
                return '';
            }
        }
    }

    const get3MonthMovingForecast = (year,currIndx) => {
        if(year == "year1"){
            if(currIndx == 0 || currIndx == 1){
                return "";
            }
            else{
                return Math.round((getActualDemand(currIndx-1)+getActualDemand(currIndx-2)+getActualDemand(currIndx-3))/3);
            }
        }
        else if(year == "year2"){
            if(getActualDemandYear2(currIndx) != ""){
                return Math.round((getActualDemandYear2(currIndx-1)+getActualDemandYear2(currIndx-2)+getActualDemandYear2(currIndx-3))/3);
            }
            else{
                return '';
            }
        }
    }

    const get3MonthMovingForecastError = (year,currIndx) => {
        if(year == "year1"){
            if(currIndx == 0 || currIndx == 1){
                return "";
            }
            else{
                return getActualDemand(currIndx) - get3MonthMovingForecast(year,currIndx);
            }
        }
        else if(year == "year2"){
            if(getActualDemandYear2(currIndx) != '' && get3MonthMovingForecast(currIndx) != ""){
                return Math.round(getActualDemandYear2(currIndx) - get3MonthMovingForecast(year,currIndx));
            }
            else {
                return '';
            }
        }
    }

    const getExponentialForecast_2 = (year, currIndx) => {
        if(year === "year1"){
            if(currIndx === 0){
                return Math.round(prevYearLastMonthEXP_2 + 0.2 * ((getActualDemand(currIndx - 1)) - prevYearLastMonthEXP_2));
            }
            else{
                const prevActualDemand = getActualDemand(currIndx - 1);
                const prevExpForecast =  getExponentialForecast_2(year, currIndx - 1);
                return Math.round(prevExpForecast + 0.2 * (prevActualDemand - prevExpForecast));
            }
        }
        else if(year == "year2"){
            if(getActualDemand(currIndx) != '' && getActualDemandYear2(currIndx) != "" && getExponentialForecast_2(currIndx) != ""){
                if(currIndx === 0){
                    return Math.round(getExponentialForecast_2("year1",11) + 0.2 * (getActualDemand(11)-getExponentialForecast_2("year1",11)));
                }
                else{
                    return Math.round(getExponentialForecast_2("year2",currIndx-1) + 0.2 * (getActualDemandYear2(currIndx-1) - getExponentialForecast_2("year2",currIndx-1)));
                }
            }
            else{
                return '';
            }
           
        }
    }

    const getExponentialForecastError_2 = (year, currIndx) => {
        if(year == "year1"){
           return getActualDemand(currIndx) - getExponentialForecast_2(year,currIndx);
        }
        else if(year == "year2"){
            if(getActualDemand(currIndx) != '' && getActualDemandYear2(currIndx) != "" && getExponentialForecast_2(currIndx) != ""){
                return getActualDemandYear2(currIndx) - getExponentialForecast_2(year,currIndx);
            }
            else{
                return "";
            }
        }
    }

    const getExponentialForecast_5 = (year, currIndx) => {
        if(year === "year1"){
            if(currIndx === 0){
                return Math.round(prevYearLastMonthEXP_5 + 0.5 * ((getActualDemand(currIndx - 1)) - prevYearLastMonthEXP_5));
            }
            else{
                const prevActualDemand = getActualDemand(currIndx - 1);
                const prevExpForecast =  getExponentialForecast_5(year, currIndx - 1);
                return Math.round(prevExpForecast + 0.5 * (prevActualDemand - prevExpForecast));
            }
        }
        else if(year == "year2"){
            if(getActualDemand(currIndx) != '' && getActualDemandYear2(currIndx) != "" && getExponentialForecast_5(currIndx) != ""){
                if(currIndx === 0){
                    return Math.round(getExponentialForecast_5("year1",11) + 0.5 * (getActualDemand(11)-getExponentialForecast_5("year1",11)));
                }
                else{
                    return Math.round(getExponentialForecast_5("year2",currIndx-1) + 0.5 * (getActualDemandYear2(currIndx-1) - getExponentialForecast_5("year2",currIndx-1)));
                }
            }
            else{
                return '';
            }
        }
    }

    const getExponentialForecastError_5 = (year, currIndx) => {
        if(year == "year1"){
           return getActualDemand(currIndx) - getExponentialForecast_5(year,currIndx);
        }
        else if(year == "year2"){
            if(getActualDemand(currIndx) != '' && getActualDemandYear2(currIndx) != "" && getExponentialForecast_5(currIndx) != ""){
                return getActualDemandYear2(currIndx) - getExponentialForecast_5(year,currIndx);
            }
            else{
                return "";
            }
        }
    }

    const getSeasonalForecast = (year, currIndx) => {
        if(year == "year1"){
            return Math.round(getActualDemand(currIndx) / seasonalIndex[currIndx]);
        }
        else if(year == "year2"){
            if(getActualDemandYear2(currIndx) != ''){
                return Math.round(getActualDemandYear2(currIndx) / seasonalIndex[currIndx]);
            }
            else{
                return "";
            }
        }
    }

    const getSeasonalForecastError = (year, currIndx) => {
        if(year == "year1"){
            return getActualDemand(currIndx) - getSeasonalForecast(year,currIndx);
        }
        else if(year == "year2"){
           if(getActualDemandYear2(currIndx) != '' && getSeasonalForecast(currIndx) != ''){
            return getActualDemandYear2(currIndx) - getSeasonalForecast(year,currIndx);
           }
           else{
            return '';
           }
        }
    }

    const calculateMapePercentage = (i) => {
        const actualDemand = parseInt(copyPrework?.attemptdata?.year2ActualDemands?.[i]);
        const forecastNextPeriod = parseInt(copyPrework?.attemptdata?.year2ForecastNextPeriod?.[i]);

        if(isNaN(actualDemand) || isNaN(forecastNextPeriod) || actualDemand == 0){
            return "";
        }

    //    let mapePer = Math.abs(parseInt(copyPrework?.attemptdata?.year2ActualDemands?.[i]) - parseInt(copyPrework?.attemptdata?.year2ForecastNextPeriod?.[i]))/parseInt(copyPrework?.attemptdata?.year2ActualDemands?.[i])*100
        let mapePer = Math.abs(actualDemand - forecastNextPeriod) / actualDemand * 100;
       if(isNaN(mapePer) || !isFinite(mapePer)){
            return "";
       }
       else{
        return Math.round(mapePer);
       }
    }

    const calculateAvgMapePercent = (i) => {
        let totalMape = 0;
        for (let index = 0; index <= i; index++) {
            totalMape += parseFloat(calculateMapePercentage(index))            
        }
        let avgMapePer = totalMape / (i+1)
       if(isNaN(avgMapePer)){
            return ""
       }
       else{
        return Math.round(avgMapePer);
       }
    }

    const getClosestForecastError = (year, currIndx) => {
        let closestError = '';
        const errors = [
            { name: 'Naive', error: currIndx == 0 ? getNaiveForecastError("year1",11) :  getNaiveForecastError("year2",currIndx-1), forecast: currIndx == 0 ? calculateNaiveForecast("year1",11) : calculateNaiveForecast("year2",currIndx-1) },
            { name: '3MonthMoving', error: currIndx == 0 ? get3MonthMovingForecastError("year1",11) :  get3MonthMovingForecastError("year2",currIndx-1), forecast:  currIndx == 0 ? get3MonthMovingForecast("year1",11) :  get3MonthMovingForecast("year2",currIndx-1) },
            { name: 'Exponential_2', error: currIndx == 0 ? getExponentialForecastError_2("year1",11) :  getExponentialForecastError_2("year2",currIndx-1), forecast: currIndx == 0 ? getExponentialForecast_2("year1",11) :  getExponentialForecast_2("year2",currIndx-1) },
            { name: 'Exponential_5', error:  currIndx == 0 ? getExponentialForecastError_5("year1",11) :  getExponentialForecastError_5("year2",currIndx-1), forecast:  currIndx == 0 ? getExponentialForecast_5("year1",11) :  getExponentialForecast_5("year2",currIndx-1) },
            { name: 'Seasonal', error: currIndx == 0 ? getSeasonalForecastError("year1",11) :  getSeasonalForecastError("year2",currIndx-1), forecast:  currIndx == 0 ? getSeasonalForecast("year1",11) :  getSeasonalForecast("year2",currIndx-1) },
        ];
    
        const validErrors = errors?.filter(e => e.error !== '');
        if(validErrors.length > 0){
            closestError = validErrors?.reduce((closest, current) => {
                return Math.abs(current.error) < Math.abs(closest.error) ? current : closest;
            });
        }
    
        return closestError?.forecast || '' ;
    };
    
    // Function to detect if the device supports touch
    const isTouchDevice = () => {
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    };
    const isSmallScreen = () => {
        return window.innerWidth <= 440;
    };

    const setBestForecastTechnique = (e) => {
        // debugger;
        setCopyPrework((prevCopyPrework)=>(
          {
            ...prevCopyPrework,
            attemptdata : {
              ...prevCopyPrework.attemptdata,
              ['bestForecastTechnique'] : forecastTechniques[e.target.selectedIndex-1]
            }
          }
        ))
        // setIsSave(true);
      } 
    // useEffect(() => {
    // if (copyPrework?.completed && copyPrework?.hasOwnProperty('score') && scoreDivRef.current && focusedScoreDiv) {
    //     scoreDivRef.current.focus();
    //     setFocusedScoreDiv(false);
    // }
    // }, [copyPrework, focusedScoreDiv]);

    useEffect(() => {
        if (Array.isArray(prework?.attemptdata) && prework?.attemptdata?.length == 0) {
            setInitialData();
        }
    }, [prework]);

    useEffect(() => {
        isSave && updatePrework();
    }, [isSave])
   
    useEffect(() => {
        // if ((isAccordionOpen?.year1 && requiredActualDemands?.year1ActualDemands) || (isAccordionOpen?.year2 && requiredActualDemands?.year2ActualDemands)) {
            setTimeout(() => {
                setColumnWidths();
            }, 0); // Set column widths on mount
        // }
    }, [prework ,isAccordionOpen]);

    useEffect(() => {
        let artifactSel = document.querySelector(".artifacts");
        let ApprowSel = document.querySelector(".App .row");
        let FooterIntro = document.querySelector('.footer-nav .footer-links .listitem');
        window.$("html, body").animate(
            {
                scrollTop: 0,
            },
            100
        );
        document.title = "Forecasting | Prework";
        if (artifactSel !== null) {
            artifactSel.style.display = "none";
        }
        if (ApprowSel !== null) {
            ApprowSel.style.minHeight = "auto";
            ApprowSel.style.minHeight = "100vh";
        }
        if (FooterIntro !== null) {
            FooterIntro.style.display = "none"; //for hide intro navigation
        }
        document.querySelector(".title").textContent = "Forecasting - Prework";
        // let localsid = localStorage.getItem("session_id") != null ? localStorage.getItem("session_id") : "";
        // let sessionId = (window.location.hash != "") ? 
        // (((window.location.hash != "") && (window.location.hash.split("#")[1].length > 20)) ? window.location.hash.split("#")[1] : localsid) : localsid;
        // if (sessionId != "") {
        //     localStorage["session_id"] = sessionId;
        //     getPrework();
        // }
        let element = document.querySelector('h1.title[aria-hidden="false"][tabindex="-1"]');
        if(element != null){
            element.classList.add('firstHeading');
        }
    }, []);

    useEffect(()=>{
        if(!headerPopup || !isOverlay){
            setTimeout(() => {
                Array.from(document.querySelectorAll(".showBtn")).map((item)=>{
                    item.setAttribute("tabindex","-1")
                })
            }, 100);
        }
    },[headerPopup,isOverlay])

    useEffect(()=>{
        window.$(".ui.accordion").accordion();
        // window.$('.ui.dropdown').dropdown();
        document.querySelector(".forecast-dropdown").addEventListener("change",setBestForecastTechnique);

        return ()=> {
            if(document.querySelector(".forecast-dropdown")){
              document.querySelector(".forecast-dropdown").removeEventListener("change",setBestForecastTechnique);
            }
          }
        // getPrework();
    },[])

    // useEffect(()=> {
    //     if(window.$('.forecast-dropdown').length !== 0 && prework?.attemptdata?.bestForecastTechnique){
    //         window.$('.forecast-dropdown').dropdown();
    //     }
    // },[prework?.attemptdata?.bestForecastTechnique])

    useEffect(()=>{
          if(copyPrework?.completed){
            document.querySelector(".forecast-dropdown").classList.add(`disabled`);
            document.querySelector(".forecast-dropdown").setAttribute("tabindex","-1");
            document.querySelector(".forecast-dropdown").classList.remove(`${FcModuleStyle.enabled}`)
          }
          else{
            document.querySelector(".forecast-dropdown").classList.add(`${FcModuleStyle.enabled}`);
            document.querySelector(".forecast-dropdown").setAttribute("tabindex","0");
            document.querySelector(".forecast-dropdown").classList.remove(`disabled`)
          }
      },[copyPrework?.completed])

    useEffect(()=>{
        if(from && from=="preworkdecisionhistory" && data){
            setPrework(data);
            setCopyPrework(data);
            setRequiredActualDemands(data?.attemptdata?.required_monthly_demands || []);
          if(document.querySelector(".footer")){
            document.querySelector(".footer").style.display = "block";
          }
          if(document.querySelector(".sv-components-column.sv-components-container-contentBottom")){
            document.querySelector(".sv-components-column.sv-components-container-contentBottom").style.display = "none";
          }
        }
        else{
          let localsid = getSession() != null ? getSession() : "";
              let sessionId = (window.location.hash != "") ? 
              (((window.location.hash != "") && (window.location.hash.split("#")[1].length > 20)) ? window.location.hash.split("#")[1] : localsid) : localsid;
      
              if (sessionId != "") {
                  setSession(sessionId);
                  getPrework();
              }
        }
      },[from,data])

    useEffect(() => {
        window.$(".ui.accordion").accordion({
            onOpen: function(){
                setColumnWidths();
            }
        });
        window.addEventListener('resize', setColumnWidths);
        setColumnWidths();
        return () => window.removeEventListener('resize', setColumnWidths);
    }, []);

    useEffect(()=>{
        if(copyPrework?.attemptdata?.required_monthly_demands){
            setRequiredActualDemands(copyPrework?.attemptdata?.required_monthly_demands || []);
        }
    },[copyPrework?.attemptdata?.required_monthly_demands])


    useEffect(()=>{
        let inputs = document.getElementsByClassName(`${FcModuleStyle["inputFields"]}`)
        if(inputs && inputs?.length>0){
          Array.from(inputs).forEach((inp)=>{
            inp.addEventListener("keydown",checkKey);
            if (!(/Android|iPad/i.test(navigator.userAgent))) {
              inp.addEventListener("input",checkKey);
            } 
          })
        }
    
      },[])

      useEffect(() => {
        if(updatedMonth.current != null && copyPrework?.attemptdata?.year2ForecastNextPeriod){
             // Now, dynamically update the live region message for NVDA
             if(copyPrework?.attemptdata?.year2ForecastNextPeriod?.[updatedMonth.current]){
                setLiveMessage(`For ${months[updatedMonth.current].full}, the values have been updated: MAPE% is ${calculateMapePercentage(updatedMonth.current) + "%"}, 
                Average MAPE is ${calculateAvgMapePercent(updatedMonth.current) + "%"}, 
                and Year 2 Actual Demand is ${copyPrework?.attemptdata?.year2ActualDemands?.[updatedMonth.current]}.`);
             }
             updatedMonth.current = null;
        }
      }, [copyPrework?.attemptdata?.year2ForecastNextPeriod,updatedMonth.current])

    // useEffect(() => {
    //     if (copyPrework?.score !== undefined) {
    //     const message = `Score: ${copyPrework.score}% (${copyPrework.score}/100 points)`;
    //     setFeedbackMessage(message);

    //     // Move focus when message updates
    //     if (scoreBlockRef.current) {
    //         scoreBlockRef.current.focus();
    //     }
    //     }
    // }, [copyPrework?.score]);

    return (
        <div className="prework container" style={preworkStyle}>
            <div className={`${FcModuleStyle.introtext} ${FcModuleStyle["mbottom"]}`}>
                <div className={`ui accordion ${FcModuleStyle["ui"]} ${FcModuleStyle["accordion"]} ${FcModuleStyle["prework-tables"]}`}>
                    <div className={`title ${isStepsContainerOpen ? "active" : ""} ${FcModuleStyle["title"]}`}
                        onClick={()=>{
                            setIsStepsContainerOpen(prev => !prev)
                        }}>
                            <h2 id="stepHeading" className={`${FcModuleStyle["intro-heading"]}`}>
                                <span>Steps</span>
                                <button className='chevron-btn' aria-expanded={isStepsContainerOpen} aria-labelledby="stepHeading">
                                    {
                                    isStepsContainerOpen ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                    : <i className={`chevron down icon`} aria-hidden="true"></i>
                                    }
                                </button>
                            </h2>
                    </div>
                    <div className={`content ${isStepsContainerOpen ? "active" : ""}`}>
                        <ol className={`transition visible ${FcModuleStyle["custom-list-ol"]} `}>
                            <li>
                                Read scenario and approach.
                            </li>
                            <li>
                                In Activity 1 you will need to forecast for each month of Year 2, beginning in January.
                            </li>
                            <li>
                                The Year 1 Table provides Actual Demand as well as the demand that forecasted using 5 different forecasting techniques: Naïve, 3–Month Moving Average, Exponential Smoothing for .2, Exponential Smooth for .5, and Seasonal. From month to month, different techniques may be more effective, which you can tell from the Forecast Error. The most effective technique is the one with a Forecast Error closest to 0.
                            </li>
                            <li>
                                Note that the Year 2 table will fill out automatically as you input your forecasts in the Activity section.
                            </li>
                            <li>
                                To get started with your own forecast:
                                <ol className={`${FcModuleStyle["sublist"]}`} type="a">
                                    <li>Review the Year 1 data. Look especially at the latest month of data to identify which forecasting strategy was most effective for that month.</li>
                                    <li>Use the <span aria-hidden="true">JAN</span><span className="sr-only">January</span> Year 2 input box in the Activity section to input your forecast. Input the forecast from the strategy that performed best in the previous month. That month Actual Demand will automatically be filled out for you.</li>
                                    <li>In the Year 2 table you can see how the different forecasting strategies performed. Remember you want to use the strategy that was most effective for the latest month. Repeat the steps each month to complete the Activity inputs.</li>
                                </ol>
                            </li>
                            <li>For Activity 2, review your forecasts and identify which forecasting technique best fit the data based on overall performance. (Typically the technique you used most frequently.)</li>
                            <li>
                                <div>
                                Click the <div style={{'display': 'inline-block'}}><span className={`${FcModuleStyle["custom-button"]} ${FcModuleStyle["save-customBtn"]}`}>Save</span></div> button to keep your progress. Once you’ve finished the assignment, click the <div style={{'display': 'inline-block'}}><span className={`${FcModuleStyle["custom-button"]} ${FcModuleStyle["submit-customBtn"]}`}>Submit</span></div> button to receive your grade and feedback.
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div className={`${FcModuleStyle.introtext} ${FcModuleStyle["mbottom"]}`}>
                <div className={`ui accordion ${FcModuleStyle["ui"]} ${FcModuleStyle["accordion"]} ${FcModuleStyle["prework-tables"]}`}>
                    <div className={`title ${isScenarioContainerOpen ? "active" : ""} ${FcModuleStyle["title"]}`}
                        onClick={()=>{
                            setIsScenarioContainerOpen(prev => !prev)
                        }}
                       >
                            <h2 id="scenarioHeading" className={`${FcModuleStyle["intro-heading"]}`}>
                                <span>Scenario</span>
                                <button className='chevron-btn' aria-expanded={isScenarioContainerOpen} aria-labelledby="scenarioHeading">
                                    {
                                    isScenarioContainerOpen ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                    : <i className={`chevron down icon`} aria-hidden="true"></i>
                                    }
                                </button>
                            </h2>
                    </div>
                    <div className={`content ${isScenarioContainerOpen ? "active" : ""}`}>
                        <p className={`${FcModuleStyle["indent-para-text"]}`}>You have been given a task to create a demand forecast for the second year of sales of a premium outdoor grill. Accurate forecasts are important for many reasons, including for the company to ensure they have the materials they need to create the products required in a certain period of time. Your objective is to minimize the forecast error, which will be measured using the Mean Absolute Percentage Error (MAPE) with a goal of being below 25%.</p>
                        <p className={`${FcModuleStyle["indent-para-text"]}`}>You have historical monthly sales data for the past year and access to software that provides forecasts based on five different forecasting techniques (Naïve, 3–Month Moving Average, Exponential Smoothing for .2, Exponential Smooth for .5, and Seasonal) to help determine the best forecast for that particular month. Based on the given data, you will identify trends and patterns to create a more accurate forecast.</p>
                    </div>
                </div>
            </div>
            <div className={`${FcModuleStyle.introtext} ${FcModuleStyle["mbottom"]}`}>
                <div className={`ui accordion ${FcModuleStyle["ui"]} ${FcModuleStyle["accordion"]} ${FcModuleStyle["prework-tables"]}`}>
                    <div className={`title ${isIntroductionOpen ? "active" : ""} ${FcModuleStyle["title"]}`} 
                        onClick={()=>{
                            setIsIntroductionOpen(prev => !prev)
                        }}
                        >
                            <h2 id="approachHeading" className={`${FcModuleStyle["intro-heading"]}`}>
                                <span>Approach</span>
                                <button className='chevron-btn' aria-expanded={isIntroductionOpen} aria-labelledby="approachHeading">
                                    {
                                        isIntroductionOpen ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                        : <i className={`chevron down icon`} aria-hidden="true"></i>
                                    }
                                </button>
                            </h2>
                    </div>
                    <div className={`content ${isIntroductionOpen ? "active" : ""}`}>
                        <p className={`${FcModuleStyle["indent-para"]}`}>Consider the previous month’s forecast to identify which technique is most effective. Use that to forecast the next month.</p>
                        <p className={`${FcModuleStyle["indent-para"]}`}>Remember to select the forecasting technique that produces the forecast error nearest to zero. For example:</p>
                        <ol className={`${FcModuleStyle["sublist"]}`} type="a">
                            <li>Naïve Forecast is 230 and the Forecast Error is -15.</li>
                            <li>3–Month Moving Forecast is 290 and the Forecast Error is -75.</li>
                            <li>Exponential Smoothing Forecast for .2 is 308 and the Forecast Error is -93.</li>
                            <li>Exponential Smoothing Forecast for .5 is 279 and the Forecast Error is -64.</li>
                            <li>Seasonal Forecast is 297 and the Forecast Error is -82.</li>
                        </ol>
                        <p className={`${FcModuleStyle["indent-para-text"]}`}>The forecast for the next month would be 230 as the Naïve Forecast had the Forecast Error closest to zero with a -15. This forecasting technique was the best performing technique for that month. You do not need to do any external analysis–the forecast error for each strategy is already calculated for you in the tables below.</p>
                    </div>
                </div>
            </div>
            <div className={`${FcModuleStyle.introtext} ${FcModuleStyle["mbottom"]}`}>
                <div className={`ui container ${FcModuleStyle["ui"]} ${FcModuleStyle["container"]} ${FcModuleStyle["prework-table-container"]}`}>
                    <table className={`ui unstackable celled structured table ${FcModuleStyle["ui"]} ${FcModuleStyle["structured"]} ${FcModuleStyle["table"]} ${FcModuleStyle["fc-table3"]}`}>
                        <thead>
                        <tr>
                            <th id="col-month" ref={el => thRefs.current[0] = el}>Month</th>
                            <th id="col-period" ref={el => thRefs.current[1] = el}>Period</th>
                            <th id="col-demand" ref={el => thRefs.current[2] = el}>Actual Demand</th>
                            <th id="col-naive" ref={el => thRefs.current[3] = el}>Naïve</th>
                            <th id="col-naiveErr" ref={el => thRefs.current[4] = el}>Naïve Forecast Error</th>
                            <th id="col-mov3" ref={el => thRefs.current[5] = el}>3–Month Moving Forecast</th>
                            <th id="col-mov3Err" ref={el => thRefs.current[6] = el}>3–Month Moving Forecast Error</th>
                            <th id="col-exp2" ref={el => thRefs.current[7] = el}>Exponential Smoothing Forecast for .2</th>
                            <th id="col-exp2Err" ref={el => thRefs.current[8] = el}>Exponential Smoothing .2 Forecast Error</th>
                            <th id="col-exp5" ref={el => thRefs.current[9] = el}>Exponential Smoothing Forecast for .5</th>
                            <th id="col-exp5Err" ref={el => thRefs.current[10] = el}>Exponential Smoothing .5 Forecast Error</th>
                            <th id="col-seasonal" ref={el => thRefs.current[11] = el}>Seasonal</th>
                            <th id="col-seasonalErr" ref={el => thRefs.current[12] = el}>Seasonal Forecast Error</th>
                        </tr>
                        </thead>
                        <tbody>

                        {/* for year1 */}
                        <React.Fragment>
                            <tr>
                                <td colSpan="13" className={`ui accordion nested-accordion ${FcModuleStyle["nested-accordion"]} ${FcModuleStyle["ui"]} ${FcModuleStyle["accordion"]}`}>
                                    <div
                                        className={`title ${FcModuleStyle["title"]} ${isAccordionOpen["year1"] ? "active" : ""}`}
                                        onClick={() => toggleAccordion("year1")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                toggleAccordion("year1");
                                            }
                                        }}
                                        
                                        aria-controls="year1-content" 
                                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                    >
                                        <button className={`${FcModuleStyle["nested-dropdown-btn"]}`} aria-expanded={isAccordionOpen["year1"]} aria-labelledby="year1Title">
                                            <i className="dropdown icon" aria-hidden="true"></i>
                                        </button>
                                        <span id="year1Title">
                                            Year 1
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            {isAccordionOpen["year1"] && (
                                <tr id="year1-content">
                                    <td colSpan="13" className={`content nested-table-container ${FcModuleStyle["nested-table-container"]} ${isAccordionOpen["year1"] ? "active" : ""}`}>
                                        <table className={`ui unstackable celled structured striped table ${FcModuleStyle["ui"]} ${FcModuleStyle["table"]} ${FcModuleStyle["nested-table"]}`}>
                                            <thead className="sr-only">
                                                <tr>
                                                    <th id="col-month-nested-nested">Month</th>
                                                    <th id="col-period-nested">Period</th>
                                                    <th id="col-demand-nested">Actual Demand</th>
                                                    <th id="col-naive-nested">Naïve</th>
                                                    <th id="col-naiveErr-nested">Naïve Forecast Error</th>
                                                    <th id="col-mov3-nested">3–Month Moving Forecast</th>
                                                    <th id="col-mov3Err-nested">3–Month Moving Forecast Error</th>
                                                    <th id="col-exp2-nested">Exponential Smoothing Forecast for .2</th>
                                                    <th id="col-exp2Err-nested">Exponential Smoothing .2 Forecast Error</th>
                                                    <th id="col-exp5-nested">Exponential Smoothing Forecast for .5</th>
                                                    <th id="col-exp5Err-nested">Exponential Smoothing .5 Forecast Error</th>
                                                    <th id="col-seasonal-nested">Seasonal</th>
                                                    <th id="col-seasonalErr-nested">Seasonal Forecast Error</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    requiredActualDemands?.year1ActualDemands?.map((monthDemand,i)=>{
                                                        return (<tr className={`${(focusedIndex == i && focusedIndex == 11) ? `${FcModuleStyle?.focused}` : ''}`}>
                                                                    <td headers="col-month-nested">
                                                                    <span className="sr-only">{months[i].full}</span> {/* Full month name for screen readers */}
                                                                    <span aria-hidden="true">{months[i].short}</span> {/* Short form visible on the screen */}
                                                                    </td>
                                                                    <td headers="col-period-nested">{i+1}</td>
                                                                    <td headers="col-demand-nested">{monthDemand}</td>
                                                                    <td headers="col-naive-nested">{calculateNaiveForecast("year1",i)}</td>
                                                                    <td headers="col-naiveErr-nested">{getNaiveForecastError("year1",i)}</td>
                                                                    <td headers="col-mov3-nested">{i < 2 ? (get3MonthMovingForecast("year1", i) !== "" ? (get3MonthMovingForecast("year1", i)) : (<span className='sr-only'>blank</span>)) : (get3MonthMovingForecast("year1", i))}</td>
                                                                    <td headers="col-mov3Err-nested">{i < 2 ? (get3MonthMovingForecastError("year1", i) !== "" ? (get3MonthMovingForecastError("year1", i)) : (<span className='sr-only'>blank</span>)) : (get3MonthMovingForecastError("year1", i))}</td>
                                                                    <td headers="col-exp2-nested">{getExponentialForecast_2("year1",i)}</td>
                                                                    <td headers="col-exp2Err-nested">{getExponentialForecastError_2("year1",i)}</td>
                                                                    <td headers="col-exp5-nested">{getExponentialForecast_5("year1",i)}</td>
                                                                    <td headers="col-exp5Err-nested">{getExponentialForecastError_5("year1",i)}</td>
                                                                    <td headers="col-seasonal-nested">{getSeasonalForecast("year1",i)}</td>
                                                                    <td headers="col-seasonalErr-nested">{getSeasonalForecastError("year1",i)}</td>
                                                                </tr>)
                                                    })
                                                }
                                            
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>

                        {/* for year2 */}
                        <React.Fragment>
                            <tr>
                                <td colSpan="13" className={`ui accordion nested-accordion ${FcModuleStyle["nested-accordion"]} ${FcModuleStyle["ui"]} ${FcModuleStyle["accordion"]}`}>
                                    <div
                                        className={`title ${FcModuleStyle["title"]} ${isAccordionOpen["year2"] ? "active" : ""}`}
                                        onClick={() => toggleAccordion("year2")}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                toggleAccordion("year2");
                                            }
                                        }}
                                        
                                        aria-controls="year2-content"
                                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                    >
                                        <button className={`${FcModuleStyle["nested-dropdown-btn"]}`} aria-expanded={isAccordionOpen["year2"]} aria-labelledby="year2Title">
                                            <i className="dropdown icon" aria-hidden="true"></i>
                                        </button>
                                        <span id="year2Title">
                                            Year 2
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            {isAccordionOpen["year2"] && (
                                <tr id="year2-content">
                                    <td colSpan="13" className={`content nested-table-container ${FcModuleStyle["nested-table-container"]} ${isAccordionOpen["year2"] ? "active" : ""}`}>
                                        <table className={`ui unstackable celled structured striped table ${FcModuleStyle["ui"]} ${FcModuleStyle["table"]} ${FcModuleStyle["nested-table"]}`}>
                                             <thead className="sr-only">
                                                <tr>
                                                    <th id="col-month-nested-nested">Month</th>
                                                    <th id="col-period-nested">Period</th>
                                                    <th id="col-demand-nested">Actual Demand</th>
                                                    <th id="col-naive-nested">Naïve</th>
                                                    <th id="col-naiveErr-nested">Naïve Forecast Error</th>
                                                    <th id="col-mov3-nested">3–Month Moving Forecast</th>
                                                    <th id="col-mov3Err-nested">3–Month Moving Forecast Error</th>
                                                    <th id="col-exp2-nested">Exponential Smoothing Forecast for .2</th>
                                                    <th id="col-exp2Err-nested">Exponential Smoothing .2 Forecast Error</th>
                                                    <th id="col-exp5-nested">Exponential Smoothing Forecast for .5</th>
                                                    <th id="col-exp5Err-nested">Exponential Smoothing .5 Forecast Error</th>
                                                    <th id="col-seasonal-nested">Seasonal</th>
                                                    <th id="col-seasonalErr-nested">Seasonal Forecast Error</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    copyPrework?.attemptdata?.year2ActualDemands?.map((monthDemand,i) => {
                                                        return (
                                                            <tr className={`${(focusedIndex == i && focusedIndex != 11) ? `${FcModuleStyle?.focused}` : ''}`}>
                                                                <td headers="col-month-nested-nested">
                                                                <span className="sr-only">{months[i].full}</span> {/* Full month name for screen readers */}
                                                                <span aria-hidden="true">{months[i].short}</span> {/* Short form visible on the screen */}
                                                                </td>
                                                                <td headers="col-period-nested-nested">{12 + i + 1}</td>
                                                                <td headers="col-demand-nested-nested">{copyPrework?.attemptdata?.year2ForecastNextPeriod?.[i] != "" ? monthDemand : <span className="sr-only">blank</span>}</td>
                                                                <td headers="col-naive-nested-nested">{((i!=0 && copyPrework?.attemptdata?.year2ForecastNextPeriod?.[i-1] != "") || i==0) ? calculateNaiveForecast("year2",i) : <span className="sr-only">blank</span>}</td>
                                                                <td headers="col-naiveErr-nested-nested">{copyPrework?.attemptdata?.year2ForecastNextPeriod?.[i] != "" ?getNaiveForecastError("year2",i) : <span className="sr-only">blank</span>}</td>
                                                                <td headers="col-mov3-nested-nested">{copyPrework?.attemptdata?.year2ForecastNextPeriod?.[i] != "" ?get3MonthMovingForecast("year2",i) : <span className="sr-only">blank</span>}</td>
                                                                <td headers="col-mov3Err-nested-nested">{copyPrework?.attemptdata?.year2ForecastNextPeriod?.[i] != "" ?get3MonthMovingForecastError("year2",i) : <span className="sr-only">blank</span>}</td>
                                                                <td headers="col-exp2-nested-nested">{copyPrework?.attemptdata?.year2ForecastNextPeriod?.[i] != "" ?getExponentialForecast_2("year2",i) : <span className="sr-only">blank</span>}</td>
                                                                <td headers="col-exp2Err-nested-nested">{copyPrework?.attemptdata?.year2ForecastNextPeriod?.[i] != "" ?getExponentialForecastError_2("year2",i) : <span className="sr-only">blank</span>}</td>
                                                                <td headers="col-exp5-nested-nested">{copyPrework?.attemptdata?.year2ForecastNextPeriod?.[i] != "" ?getExponentialForecast_5("year2",i) : <span className="sr-only">blank</span>}</td>
                                                                <td headers="col-exp5Err-nested-nested">{copyPrework?.attemptdata?.year2ForecastNextPeriod?.[i] != "" ?getExponentialForecastError_5("year2",i) : <span className="sr-only">blank</span>}</td>
                                                                <td headers="col-seasonal-nested-nested">{copyPrework?.attemptdata?.year2ForecastNextPeriod?.[i] != "" ?getSeasonalForecast("year2",i) : <span className="sr-only">blank</span>}</td>
                                                                <td headers="col-seasonalErr-nested-nested">{copyPrework?.attemptdata?.year2ForecastNextPeriod?.[i] != "" ?getSeasonalForecastError("year2",i) : <span className="sr-only">blank</span>}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                </tbody>
                    </table>
                </div>
            </div>
            <div className={`${FcModuleStyle.introtext} ${FcModuleStyle["mbottom"]}`}>
                <div className={`ui accordion ${FcModuleStyle["ui"]} ${FcModuleStyle["accordion"]} ${FcModuleStyle["prework-tables"]}`}>
                    <div className={`title ${isActivityOpen ? "active" : ""} ${FcModuleStyle["title"]}`} 
                        onClick={()=>{
                            setIsActivityOpen(prev => !prev)
                        }}
                        >
                            <h2 id="activity1Heading" className={`${FcModuleStyle["intro-heading"]}`}>
                                <span>Activity 1: Year 2 Forecast</span>
                                <button className='chevron-btn' aria-expanded={isActivityOpen} aria-labelledby="activity1Heading">
                                    {
                                        isActivityOpen ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                        : <i className={`chevron down icon`} aria-hidden="true"></i>
                                    }
                                </button>
                            </h2>
                    </div>
                    <div className={`content ${isActivityOpen ? "active" : ""}`}>
                        <div className={`${FcModuleStyle.introtext} ${FcModuleStyle["mbottom"]}`}>
                            {
                                !copyPrework?.completed && <div className="sr-only" aria-live="polite">{liveMessage}</div>
                            }
                            
                            <div className={`ui container ${FcModuleStyle["ui"]} ${FcModuleStyle["container"]} ${FcModuleStyle["prework-table-container"]} ${FcModuleStyle["tables-block"]}`}>
                                <table className={`ui unstackable celled structured striped table ${FcModuleStyle["ui"]} ${FcModuleStyle["structured"]} ${FcModuleStyle["table"]} ${FcModuleStyle["fc-table"]}`}>
                                    <colgroup span="3"></colgroup>
                                    <col />
                                    <thead>
                                        <tr className={`${FcModuleStyle["table1-row"]}`}>
                                            <th scope="col">Forecast next period</th>
                                            <th scope="col" className={`five wide`}>Year 2</th>
                                            <th scope="col">MAPE%</th>
                                            <th scope="col">Average MAPE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {months?.map((month, index) => {
                                            const inputValue = copyPrework?.attemptdata?.year2ForecastNextPeriod?.[index];
                                            const isMatch = inputValue == getClosestForecastError("year2", index)
                                            return (
                                            <tr key={index}>
                                                <td scope="row">
                                                    <span className="sr-only">{month.full}</span> {/* Full month name for screen readers */}
                                                    <span aria-hidden="true">{month.short}</span> {/* Short form visible on the screen */}
                                                </td>
                                                <td>
                                                    <div className={`${FcModuleStyle["input-flex"]}`}>
                                                        <input
                                                            type="number"
                                                            className={`${FcModuleStyle["inputFields"]}`}
                                                            data-value={copyPrework?.attemptdata?.year2ForecastNextPeriod?.[index]}
                                                            value={copyPrework?.attemptdata?.year2ForecastNextPeriod?.[index]}
                                                            onChange={(e) => {updateForecastNextYear(e,index)}}
                                                            onFocus={()=>{
                                                                if(index == 0){
                                                                    setFocusedIndex(11)
                                                                }
                                                                else{
                                                                    setFocusedIndex(index-1)
                                                                }
                                                            }}
                                                            onKeyDown={(e) => checkKey(e)}
                                                            // aria-label={`${months[index].full} Year 2 forecast`}
                                                            min={0}
                                                            max={999}
                                                            maxLength={3}
                                                            step={1}
                                                            disabled={copyPrework?.completed || ((index != 0) && (copyPrework?.attemptdata?.year2ActualDemands?.[index-1] == "")) || !(prework?.mode == "do" || prework?.mode == "preview")}
                                                        />
                                                        {
                                                            copyPrework?.completed ? 
                                                            ( inputValue !== '' && isMatch
                                                            ?  <span className={`${FcModuleStyle["correct-sign"]}`}>
                                                                <span className="sr-only">correct forecast value</span>
                                                            </span>
                                                                
                                                            : <span className={`${FcModuleStyle["incorrect-sign"]}`}>
                                                                <span className="sr-only">incorrect forecast value</span>
                                                            </span>
                                                            ) 
                                                            : ""
                                                        }
                                                    </div>
                                                </td>
                                                <td>{calculateMapePercentage(index) ? calculateMapePercentage(index) : <span className="sr-only">blank</span>}{calculateMapePercentage(index) && "%"}</td>
                                                <td>{calculateAvgMapePercent(index) ? calculateAvgMapePercent(index) : <span className="sr-only">blank</span>}{calculateAvgMapePercent(index) && "%"}</td>
                                            </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>

                                <table id="actualDemandTable" className={`ui unstackable celled structured striped table ${FcModuleStyle["ui"]} ${FcModuleStyle["structured"]} ${FcModuleStyle["table"]} ${FcModuleStyle["fc-table"]}`}>
                                    <colgroup span="3"></colgroup>
                                    <col />
                                    <thead>
                                        <tr>
                                            <th colSpan="3" scope="colgroup">Actual Demand</th>
                                            <th></th>
                                        </tr>
                                        <tr>
                                            <th scope="col">Month</th>
                                            <th scope="col">Year 1</th>
                                            <th scope="col">Year 2</th>
                                            <th scope="col">Seasonal Index</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {months.map((month, index) => (
                                            <tr key={index}>
                                                <td scope="row">
                                                <span className="sr-only">{month.full}</span> {/* Full month name for screen readers */}
                                                <span aria-hidden="true">{month.short}</span> {/* Short form visible on the screen */}
                                                </td>
                                                <td>{requiredActualDemands?.year1ActualDemands?.[index]}</td>
                                                <td>
                                                    <span>
                                                        {copyPrework?.attemptdata?.year2ForecastNextPeriod?.[index] != "" ? copyPrework?.attemptdata?.year2ActualDemands?.[index] : ''}
                                                    </span>
                                                </td>
                                                <td>{seasonalIndex?.[index]}</td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>                       
            <div className={`${FcModuleStyle.introtext} ${FcModuleStyle["mbottom"]}`}>
                <div className={`ui accordion ${FcModuleStyle["ui"]} ${FcModuleStyle["accordion"]} ${FcModuleStyle["prework-tables"]}`}>
                    <div className={`title ${isActivity2Open ? "active" : ""} ${FcModuleStyle["title"]}`} 
                        onClick={()=>{
                            setIsActivity2Open(prev => !prev)
                        }}
                        >
                            <h2 id="activity2Heading" className={`${FcModuleStyle["intro-heading"]}`}>
                                <span>Activity 2: Forecast Technique Analysis</span>
                                <button className='chevron-btn' aria-expanded={isActivity2Open} aria-labelledby="activity2Heading">
                                    {
                                        isActivity2Open ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                        : <i className={`chevron down icon`} aria-hidden="true"></i>
                                    }
                                </button>
                            </h2>
                    </div>
                    <div className={`content ${isActivity2Open ? "active" : ""}`}>
                        <div className={`${FcModuleStyle["forecast-choice"]}`}>
                            <label htmlFor="forecastDropdown"><strong>Forecasting technique that best fits the data: </strong></label>
                            <select id="forecastDropdown" className={`forecast-dropdown ${FcModuleStyle["forecast-dropdown"]}`}  disabled={copyPrework?.completed} value={copyPrework?.attemptdata?.bestForecastTechnique || ""} >
                            <option value="" selected={!copyPrework?.attemptdata?.bestForecastTechnique} >Select</option>
                            {
                                forecastTechniques.map((technique, i)=> (
                                    <option 
                                        key={i}
                                        value={technique.i}
                                        data-value={technique.i}
                                        // selected = {copyPrework?.attemptdata?.bestForecastTechnique == technique}
                                    >
                                        {technique}
                                    </option>
                                ))
                            }
                            </select>
                            {
                                copyPrework?.completed ? 
                                ( (copyPrework?.completed && copyPrework?.attemptdata?.bestForecastTechnique == correctForecastTechnique)
                                ?   <span 
                                        id="forecastResultSign"
                                        className={`${FcModuleStyle["correct-sign"]}`} 
                                        // tabIndex={-1}
                                    >
                                        {/* <span className="sr-only" role="alert" aria-live="assertive">Correct forecast technique.</span> */}
                                    </span>
                                    : <span 
                                        id="forecastResultSign"
                                        className={`${FcModuleStyle["incorrect-sign"]}`} 
                                        // tabIndex={-1}
                                    >
                                        {/* <span className="sr-only" role="alert" aria-live="assertive">Incorrect forecast technique.</span> */}
                                    </span>
                                ) 
                                : ""
                            }
                        </div>
                        
                    </div>
                </div>
            </div>
            <div className={`${FcModuleStyle["fc-prework-btn-container"]}`}>
                <div className={`${FcModuleStyle["save-submit-block"]}`}>
                    {  
                        !(copyPrework?.completed) ?
                            <Button 
                            btnClass={`title ui label`}   
                            clickEventHandler={()=>{
                                setIsSave(true);
                                isToActivateToaster.current = true;
                              }}
                            customBtnStyle={{
                            pointerEvents: (isRequestLoading || copyPrework?.completed) ? 'none' : 'auto',
                            zIndex: 1,
                            width: '80px',
                            cursor: 'pointer',
                            marginLeft: '0px'
                            }}
                            disabled={isRequestLoading || copyPrework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}
                            btnName={"Save"}
                            btnParentStyle={{display:"inline-block"}}
                            />
                        :""
                   }
                   {
                        !(copyPrework?.completed) ?
                        <Button 
                            btnClass={`title ui label`}   
                            clickEventHandler={submitPrework} 
                            customBtnStyle={{
                            zIndex: 1,
                            pointerEvents: (isRequestLoading) ? 'none' : 'auto',
                            width: '90px',
                            cursor: 'pointer',
                            marginLeft: '20px'
                            }}
                            disabled={isRequestLoading || copyPrework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}
                            btnName={"Submit"}
                        />
                        :""
                    }
                </div>
       
        <div id="saveToaster" role="alert" className={`ui message ${FcModuleStyle['save-toaster']}`} style={{"display": "none"}}>
          <p>Your data is saved, to complete activity please click on Submit.</p>
        </div>
        {(copyPrework?.completed && copyPrework?.hasOwnProperty('score')) ? 
            <div className={FcModuleStyle["score-container"]} role="region" aria-live="polite">
                <div className={FcModuleStyle["score-div"]} id="preworkScoreBlock" ref={scoreBlockRef} tabIndex={-1} >   
                    {isActivity2Open && (
                        <span className="sr-only">
                            {copyPrework?.attemptdata?.bestForecastTechnique === correctForecastTechnique
                            ? "Correct forecast technique."
                            : "Incorrect forecast technique."}
                        </span>
                    )}
                   { `Score: ${copyPrework.score}% (${copyPrework.score}/100 points)`}
                {/* {copyPrework?.attemptdata?.bestForecastTechnique === correctForecastTechnique
                    ? `Score: ${copyPrework.score}% (${copyPrework.score}/100 points)`
                    : `Score: ${copyPrework.score}% (${copyPrework.score}/100 points)`} */}
                </div>
                <div className={`${FcModuleStyle["completionbar"]}`}>Click 
                <Button 
                        btnClass={`title ui label`}   
                        clickEventHandler={resetPrework} 
                        customBtnStyle={{
                            pointerEvents: (isRequestLoading) ? 'none' : 'auto',
                            zIndex: 1,
                            cursor: 'pointer',
                            marginLeft: '20px',
                            width: '75px',
                            opacity: (isRequestLoading) ? 0.5 : 1,
                            margin: "3px 8px",
                            marginLeft : "8px"
                        }}
                        // btnParentStyle={{display:"inline-block"}}
                        btnParentStyle={{display:"block"}}
                        btnName={"Retry"}
                        disabled={!(prework?.mode == "do" || prework?.mode == "preview")}
                />
                   to attempt again <strong>(remaining attempts: {copyPrework?.remattempt})</strong>. Click 
                   <Button 
                  btnClass={`title ui label`}   
                  clickEventHandler={handlePopupExitSim} 
                  customBtnStyle={{
                    zIndex: 1,
                    cursor: 'pointer',
                    marginLeft: '20px',
                    width: '75px',
                     margin: "3px 8px",
                     marginLeft : "8px"
                  }}
                //   btnParentStyle={{display:"inline-block"}}
                btnParentStyle={{display:"block"}}
                  btnName={"Close"}
                />
                to exit.</div>
            </div>
            : ""
        }
            </div>
        </div>
    )
};
export default Prework;